export const START_LOADING = 'START_LOADING';
export const DONE_LOADING = 'DONE_LOADING';

export const startLoading = (loadingItem) => ({
  type: START_LOADING,
  loadingItem,
});

export const doneLoading = (loadingItem) => ({
  type: DONE_LOADING,
  loadingItem,
});
